export default {
  data() {
    return {
      errorException: '',
      newConstructionAttempts: 0,
      newConstructionModal: false,
    };
  },
  watch: {
    newConstructionModal(value) {
      if (value) {
        this.analytics.click.newConstructionModalOpen();
      }
    },
  },
  methods: {
    newConstructionIterateAttempt() {
      this.newConstructionAttempts += 1;

      if (this.newConstructionAttempts > 1) {
        this.newConstructionModal = true;
      }
    },
    newConstructionResetAttempts() {
      this.newConstructionAttempts = 0;
      this.newConstructionModal = false;
      // TODO: THIS IS NOT FIRING CORRECTLY
      // this.analytics.click.newConstructionModalClose('Edit');
    },
    newConstructionEvaluateAddress(addressResponse) {
      // If is 422 response override allowed
      // and 422 response has an exception matching InvalidPrimaryInformationException
      // We should trigger new construction flow logic

      if (addressResponse?.xhr?.overrideAllowed
        && (addressResponse?.xhr?.exception === 'InvalidPrimaryInformationException'
          || addressResponse?.xhr?.exception === 'UnneededSecondaryInformationException'
          || addressResponse?.xhr?.exception === 'InvalidSecondaryInformationException'
          || addressResponse?.xhr?.exception === 'NewAddressFieldFullAddressException'
          || addressResponse?.xhr?.exception === 'AmsInvalidAddressException')) {
        this.newConstructionIterateAttempt();
        this.errorException = addressResponse?.xhr?.exception || addressResponse.amsStatusCode;

        // scroll to error on page
        (async () => {
          await this.$nextTick();
          await this.scrollToFirstError();
        })();
      } else {
        this.newConstructionResetAttempts();
      }
    },
    async newConstructionOverride(recentConstruction = false) {
      const newAddressResponse = await this.$coa.addressSave({
        addressType: 'NEW',
        streetAddress: this.newStreetAddress,
        city: this.newCity,
        state: this.newState,
        zipCode: this.newZipCode,
        urbanizationName: null,
        privateMailbox: this.newPrivateMailbox || null,
        poBoxNumber: this.newPoBoxNumber || null,
        recentConstruction,
        overrideAms: true,
      });

      this.newConstructionResetAttempts();
      // coaCheckHandle after the old/newAddress response
      const coaCheckHandle = await this.$coa.coaCheck();

      // Throw coaCheckModal if 'CoaCheckException'
      if (coaCheckHandle?.error) {
        const { exception } = coaCheckHandle.xhr;
        if (exception === 'CoaCheckException') {
          this.coaCheckModal = true;
          this.defaultException('DUPCOAEXCEPTION');
          this.$store.commit('DISABLE_LOADER');
          return;
        }
      }

      this.newAddressError = newAddressResponse?.xhr?.exception || '';
      if (newAddressResponse?.xhr?.exception === 'OldAndNewAddressMatchException') {
        this.oldAddressError = 'OldAndNewAddressMatchException';
      }

      if (newAddressResponse?.uuid) {
        this.newAddressError = '';
        this.analytics.click.newConstructionModalClose(recentConstruction ? 'Yes' : 'No');
        this.next({ errorException: this.errorException }); // provided by the controller
      }
    },

    async businessNewConstructionOverride(recentConstruction) {
      this.recentConstruction = recentConstruction;
      this.overrideAms = true;
      this.newAddressError = '';
      this.analytics.click.newConstructionModalClose(recentConstruction ? 'Yes' : 'No');
      this.newConstructionResetAttempts();
    },
  },
};
